<script lang="ts" setup>
import Modal from '@/common/components/Modal.vue';
import SvgIcon from '@/common/components/SvgIcon.vue';
import { useI18n } from '@/i18n/useI18n';

// Using composables
const { trans } = useI18n();

// Emits
const emit = defineEmits(['close', 'confirm']);

// Methods
const onClickClose = () => {
	emit('close');
};

const onClickGenerate = () => {
	emit('confirm');
};
</script>

<template>
	<Modal open @close="onClickClose">
		<div class="relative mx-auto my-auto max-w-lg rounded bg-white px-8 py-8 lg:w-[470px]">
			<button
				class="absolute right-0 top-0 mr-2 mt-2 rounded bg-white p-1 hover:bg-gray-100 hover:bg-opacity-25"
				@click="onClickClose"
			>
				<SvgIcon name="close-modal" class="h-6 w-6 fill-current text-gray-700" />
			</button>

			<div>
				<SvgIcon name="alert" class="mx-auto mb-2 h-12 w-12 fill-current text-yellow-500" />
				<h1 class="mb-3 text-center text-2xl font-semibold text-gray-800">{{ trans('We need confirmation!') }}</h1>
				<p class="mb-0 text-center leading-normal text-gray-600">
					{{
						trans(
							'You will be redirected to a new AI-generated template. The current template will be closed, but you can access it through my projects button.'
						)
					}}
				</p>
				<button
					class="mx-2 mt-6 flex h-14 w-full items-center justify-center rounded border-2 border-blue-500 bg-blue-500 px-4 text-lg font-semibold text-white hover:border-blue-400 hover:bg-blue-400"
					@click.stop="onClickGenerate"
				>
					{{ trans('Generate Presentation') }}
				</button>
			</div>
		</div>
	</Modal>
</template>
